import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';
const config = {
  apiKey: "AIzaSyBNyldjEt3mZOaGRZMYJz3AG-vbxpTkZfw",
  authDomain: "agrabiz-8c47a.firebaseapp.com",
  databaseURL: "https://agrabiz-8c47a.firebaseio.com",
  projectId: "agrabiz-8c47a",
  storageBucket: "agrabiz-8c47a.firebasestorage.app",
  messagingSenderId: "117536991265",
  appId: "1:117536991265:web:5517a3b2ef29f366",
  measurementId: "G-M0X60Y5JJM"
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}
// ----- Sign in anonymously to avoid PERMISSION_DENIED in v7 -----
firebase.auth().signInAnonymously().catch(err => console.error('Auth error:', err));

const db = firebase.database();

export { db };
